import { useQuery } from "@/api/swr/useQuery";
import { answeringAssessmentSchema } from "@/schema/console/checking-assessments/AnsweringAssessment";

type Config = Parameters<typeof useQuery<typeof answeringAssessmentSchema>>[2];

export function useGetPendingAssessment(id: string, config?: Config) {
  return useQuery(
    answeringAssessmentSchema,
    `/console/pending_assessments/${id}`,
    config,
  );
}
